import { Heading, SegmentedTabs, Text } from "@overmap-ai/blocks"
import { selectAssetTypeById, selectAssetTypeFieldsById, selectAttachmentsOfAssetTypeFields } from "@overmap-ai/core"
import { FormBuilder } from "@overmap-ai/forms"
import { getRouteApi } from "@tanstack/react-router"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { useDeserializeFieldSchemaConfig, useHydrateFieldsWithAttachments } from "../../components/Form/hooks"
import { sdk } from "../../sdk"
import { useAppSelector, useShallowEqaulSelector } from "../../store"

const routeApi = getRouteApi(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId",
)

export const AssetTypeFieldsRevisionSettingsDetailView = memo(() => {
	const { assetTypeId, assetTypeFieldsId } = routeApi.useParams()
	const assetType = useAppSelector(selectAssetTypeById(assetTypeId))
	const assetTypeFields = useAppSelector(selectAssetTypeFieldsById(assetTypeFieldsId))
	const attachments = useShallowEqaulSelector(selectAttachmentsOfAssetTypeFields(assetTypeFieldsId))

	if (!assetType || !assetTypeFields || assetTypeFields.asset_type !== assetType.uuid) {
		throw new Error(`Expected asset type fields ${assetTypeFieldsId} to belong to asset type ${assetTypeId}.`)
	}

	const revisionLabel =
		assetTypeFields.revision === undefined ? "Pending revision" : `Revision ${assetTypeFields.revision}`

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(assetTypeFields.fields)

	const fieldsWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.assetTypeFieldsAttachments,
	)

	return (
		<ViewContainer>
			<section className="flex size-full flex-col gap-4 overflow-hidden">
				<Heading size="xl" className="shrink-0 truncate">
					{assetType.name}
					&nbsp;
					<Text accentColor="base">{revisionLabel}</Text>
				</Heading>

				<FormBuilder.Root initialFields={fieldsWithImages} hideSave hideCancel>
					<SegmentedTabs.Root
						defaultValue="edit"
						className="flex min-h-0 w-full grow flex-col gap-4 overflow-hidden"
					>
						<SegmentedTabs.List className="flex" accentColor="base" size="sm" variant="surface">
							<SegmentedTabs.Trigger className="grow basis-1" value="edit">
								List
							</SegmentedTabs.Trigger>
							<SegmentedTabs.Trigger className="grow basis-1" value="flow">
								Flow
							</SegmentedTabs.Trigger>
							<SegmentedTabs.Trigger className="grow basis-1" value="preview">
								Preview
							</SegmentedTabs.Trigger>
						</SegmentedTabs.List>

						<SegmentedTabs.Content value="edit" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.ListBuilder />
						</SegmentedTabs.Content>

						<SegmentedTabs.Content value="flow" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.FlowBuilder />
						</SegmentedTabs.Content>

						<SegmentedTabs.Content value="preview" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.Preview />
						</SegmentedTabs.Content>
					</SegmentedTabs.Root>
				</FormBuilder.Root>
			</section>
		</ViewContainer>
	)
})
AssetTypeFieldsRevisionSettingsDetailView.displayName = "AssetTypeFieldsRevisionSettingsDetailView"
